const IMAGE_SERVER = 'https:/*                 */

export const createImageUrl = (imageId: string, format?: string) => `${IMAGE_SERVER}${imageId}${format ? `?${format}` : ''}`;
